
<div class="toggle_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"

>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
</div>

  <ng-container *ngIf="gridView">




  <form [formGroup]="landParcelArrayForm">
<div class="entry_values">
  <div class="entry" *ngFor="let landParcel of landParcelArrayForm.get('LandParcels')['controls']; index as i"
  (click)="onEdit(landParcel.value, i)"
  style="cursor: pointer;"
  >
    <h1 class="section_name">
      <span>{{i + 1}}.</span>
      <div class="first_point">
        <span class="name">{{landParcel?.value.SectionName}}- </span>
      <span class="id">{{landParcel?.value.RowIdLinkage}}</span>
      </div>
      <i class="ti-trash" (click)="onDelete(i)"></i>
    </h1>

    <div class="other_info">
      <p class="purpose">
        <span>Purpose: </span>
        <span>{{getPurposeName(landParcel?.value.PurposeId)}}</span>
      </p>

      <p class="net_area">
        <span>Net Area: </span>
        <span>{{landParcel?.value.TotalArea}}</span>
      </p>

      <p class="uom">
        <span>Measuring Unit: </span>
        <span>{{getMeasureName(landParcel?.value.MeasureId)}}</span>
      </p>

      <p class="cost">
        <span>Cost: </span>
        <span>{{landParcel?.value.Cost}}</span>
      </p>

      <p class="map">
        <span>Map Url: </span>
        <a href="{{appConfig.leftvalue + landParcel.value.URLMap}}" target="_blank">View Map</a>
      </p>

      <p class="map">
        <span>Acre: </span>
        <span>{{landParcel.value.Acre}}</span>
      </p>

      <p class="map">
        <span>Hectare: </span>
        <span>{{landParcel.value.Hectare}}</span>
      </p>

      <p class="map">
        <span>SqKM: </span>
        <span>{{landParcel.value.SqKM}}</span>
      </p>

      <p class="map">
        <span>SqM: </span>
        <span>{{landParcel.value.SqM}}</span>
      </p>

      <p class="map">
        <span>SqFeet: </span>
        <span>{{landParcel.value.SqFeet}}</span>
      </p>

      <p class="map">
        <span>Roods: </span>
        <span>{{landParcel.value.Roods}}</span>
      </p>

      <p class="map">
        <span>Perche: </span>
        <span>{{landParcel.value.Perche}}</span>
      </p>

      <p class="map">
        <span>Plot: </span>
        <span>{{landParcel.value.Plot}}</span>
      </p>
    </div>
  </div>


</div>
</form>
</ng-container>

<div class="card mt-3 " *ngIf="listView">
  <div class="table-responsive">
  <table class="table table-hover" >
    <thead>
      <tr>
        <th scope="col">S/N</th>
        <th scope="col">Section Name</th>
        <th scope="col">RowLink</th>
        <th scope="col">Purpose</th>
        <th scope="col">Net Area</th>
        <th scope="col">Measuring Unit</th>
        <th scope="col">Cost</th>
        <th scope="col">Map Url</th>
        <th scope="col">Acre</th>
        <th scope="col">Hectare</th>
        <th scope="col">SqKM</th>
        <th scope="col">SqM</th>
        <th scope="col">SqFeet</th>
        <th scope="col">Roods</th>
        <th scope="col">Perche</th>
        <th scope="col">Plot</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody >
      <tr *ngFor="let landParcel of landParcelArrayForm.get('LandParcels')['controls']; index as i"
      >
        <th scope="row">{{i + 1}}</th>
        <td>{{landParcel?.value.SectionName}}</td>
        <td>{{landParcel?.value.RowIdLinkage}}</td>
        <td> {{getPurposeName(landParcel?.value.PurposeId)}}</td>
        <td>{{landParcel?.value.TotalArea}}</td>
        <td>{{getMeasureName(landParcel?.value.MeasureId)}}</td>
        <td>{{landParcel?.value.Cost}}</td>
        <td><a href="{{appConfig.leftvalue + landParcel.value.URLMap}}" target="_blank">View Map</a></td>
        <td>{{landParcel.value.Acre}}</td>
        <td>{{landParcel.value.Hectare}}</td>
        <td>{{landParcel.value.SqKM}}</td>
        <td>{{landParcel.value.SqM}}</td>
        <td>{{landParcel.value.SqFeet}}</td>
        <td>{{landParcel.value.Roods}}</td>
        <td>{{landParcel.value.Perche}}</td>
        <td>{{landParcel.value.Plot}}</td>
        <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
          <i class="ti-pencil" (click)="onEdit(landParcel.value, i)"></i>
          <i class="ti-trash" (click)="onDelete(i)"></i>
         </td>
      </tr>

    </tbody>
  </table>
</div>
</div>
